<template>
  <div class="sv-search-error">
    <div class="text">
      <h2>{{ $t("plp.messages.noresults") }}<br /></h2>
      <p>{{ $t("plp.messages.notfound") }}</p>
    </div>
  </div>
</template>
<style lang="scss">
@use "@/assets/scss/product-listing/sv-search-error.scss" as *;
</style>
